import { useEffect, useState } from 'react'
import { useQuery } from 'convex/react'
import { api } from '../convex_generated/api'

// Maps the server-side generation phase to a user-facing label.
const PHASE_LABELS: Record<string, string> = {
  preparing: 'Preparing…',
  synopsis: 'Studying the book…',
  writing: 'Writing your chapter…',
  saving: 'Saving your draft…',
}

// Shown before the first real phase arrives (or if the row isn't visible yet).
const FALLBACK = ['Warming up…', 'Thinking…', 'Composing…']

/**
 * Live status for an in-flight AI generation: the real server phase
 * (via a reactive subscription) plus an elapsed-seconds counter. Pass
 * `active` = true only while a generation is running.
 */
export function useGenerationProgress(active: boolean): { label: string; elapsed: number } {
  const [elapsed, setElapsed] = useState(0)
  const [tick, setTick] = useState(0)

  const gen = useQuery(api.aiBilling.getActiveGeneration, active ? {} : 'skip') as
    | { phase?: string; createdAt?: number }
    | null
    | undefined

  useEffect(() => {
    if (!active) {
      setElapsed(0)
      setTick(0)
      return
    }
    const start = Date.now()
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - start) / 1000))
      setTick((t) => t + 1)
    }, 1000)
    return () => clearInterval(id)
  }, [active])

  const phaseLabel = gen?.phase ? PHASE_LABELS[gen.phase] : undefined
  const label = phaseLabel ?? FALLBACK[tick % FALLBACK.length]
  return { label, elapsed }
}
